import React from 'react'

import { withMessages } from '../../components/Msg'

class ChatRoomIframe extends React.Component {
  render() {
    const { src, title } = this.props
    return (
      <iframe
        style={{ width: '100%', height: '100%', border: 'none' }}
        scrolling="no"
        src={src}
        title={title}
      />
    )
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.src !== nextProps.src
  }
}

export default withMessages(ChatRoomIframe)



// WEBPACK FOOTER //
// ./src/addons/chat/ChatRoomIframe.js